import { createContext, Dispatch, SetStateAction, useContext, useState } from "react"

// Define the shape of the context value
type SelectedSparePartPositionContextType = {
  selectedSparePartPosition: string | undefined
  setSelectedSparePartPosition: Dispatch<SetStateAction<string | undefined>>
}

export const SelectedSparePartPositionContext = createContext<SelectedSparePartPositionContextType | undefined>(
  undefined
)

// Custom hook to use the context
export const useSelectedSparePartPosition = () => {
  const context = useContext(SelectedSparePartPositionContext)
  if (!context) {
    //comment throwing error to be able to use the SparePartTable without the SelectedSparePartPositionProvider
    //(e.g in ResultsSparePartRow)
    //throw new Error("useSelectedSparePartPosition must be used within a SelectedSparePartPositionProvider")
  }
  return context
}

const SelectedSparePartPositionProvider = ({ children }) => {
  const [selectedSparePartPosition, setSelectedSparePartPosition] = useState<string | undefined>(undefined)
  return (
    <SelectedSparePartPositionContext.Provider value={{ selectedSparePartPosition, setSelectedSparePartPosition }}>
      {children}
    </SelectedSparePartPositionContext.Provider>
  )
}

export default SelectedSparePartPositionProvider
